import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import pengajuanTagihanProsesService from "../../services/pengajuanTagihanProsesService";
import Cookies from "js-cookie";

export const initialState = {
    loading_pengajuan_tagihan_proses: false,
    data_pengajuan_tagihan_proses: [],
    showMessage:false,
    message:'',
}


export const getDataPengajuanTagihanProses = createAsyncThunk('pengajuan_tagihan_proses/data',async (data, { rejectWithValue }) => {
    try {
        const response = await pengajuanTagihanProsesService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const pengajuanTagihanProsesSlice = createSlice({
    name: 'pengajuan_tagihan_proses',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_pengajuan_tagihan_proses = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPengajuanTagihanProses.fulfilled, (state, action) => {
                state.loading_pengajuan_tagihan_proses = false
                state.data_pengajuan_tagihan_proses = action.payload??[]
            })
            .addCase(getDataPengajuanTagihanProses.pending, (state) => {
                state.loading_pengajuan_tagihan_proses = true
            })
            .addCase(getDataPengajuanTagihanProses.rejected, (state, action) => {
                state.loading_pengajuan_tagihan_proses = false
                state.data_pengajuan_tagihan_proses = action.payload
            })
    },
})

export const {
    showLoading,
} = pengajuanTagihanProsesSlice.actions

export default pengajuanTagihanProsesSlice.reducer
